// Волна 37, участок «Найм» (боты «золото+»; ручки — configs/botW37Recruitment,
// применение — decisions/decideRecruitmentStep): правила найма на оборону своих
// городов. Подчасти и их гейты (checkIfW36Feature + isPreW37…Player):
//  T — заслон города с угрозой захвата В ЭТОМ раунде (отряды еще не ходивших
//      противников или их фантомный найм, evaluation/w37Threat), в том числе
//      сверх общего потолка армии и без накоплений на стройку; размер — чтобы
//      пережить ожидаемый урон, докупка в той же фазе;
//  F — слоты армии сверх потолка при большом запасе — только под казармы
//      фронтирных городов без своего отряда; держатель из накоплений волны 35 —
//      не обязательно самый дешевый тип;
//  E — дорогие типы фракции первыми при большом запасе; d20 после запрета с
//      R10 — на казарме у рабочего лагеря;
//  A — казармы у лагеря и в городах с арсеналом первыми, свежему найму в городе
//      с арсеналом — размер в той же фазе.
// Модуль без Phaser и стора, чтобы правила покрывались юнит-тестами напрямую;
// угрозу городам (getW37ThisRoundCityThreats из evaluation/w37Threat) и
// фронтир читает контекст найма в decideRecruitmentStep.
import {getUnitMaxSizeForFaction, getUnitPrice, getUnitTypeConfig, UNIT_TYPES} from "../../../configs/units";
import {ADDITIONAL_SUPPLY_SPEED} from "../../../configs/supply";
import {KEY_POINT_INCOME} from "../../../configs/income";
import {
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D10,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D12,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D20,
  POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D8,
} from "../../../configs/policy/totalitarianism";
import {calcW35HolderSizePurchases} from "../../../configs/botLateHire";
import {COMMON_BUILDING_TOKENS, KEY_POINT_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {NEUTRAL_PLAYER_ID} from "../../../constants/players";
import {FACTIONS} from "../../../constants/factions";
import {POLICIES} from "../../../constants/policies";
import {getAllQuartersOfCity} from "../../gameState/getAllQuartersOfCity";
import {getHexDistance} from "../../coords/getHexDistance";
import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {getSizeRecruitmentPrice} from "../../recruitment/getSizeRecruitmentPrice";
import {
  isPreW37CampArsenalHirePlayer,
  isPreW37FrontierHirePlayer,
  isPreW37RichUnitsPlayer,
  isPreW37ThreatHirePlayer,
} from "../abTestGates";
import {BOT_EXPECTED_DICE_PENALTY} from "../botConfig";
import {checkIfW36Feature} from "./goldPlus";
import {CITY_THREAT_LEVELS} from "./cityCaptureThreat";
import {checkIfW37ThisRoundThreat} from "./w37Threat";

/**
 * Подчасти участка, действующие у игрока (бот золото+ и не в legacy-наборе
 * подчасти). null — ни одной: этап найма идет прежним кодом дословно
 */
export const getW37HireFeatures = (player, gameType) => {
  if (!player) {
    return null;
  }
  const features = {
    isThreatHire: checkIfW36Feature(player, gameType, isPreW37ThreatHirePlayer),
    isFrontierHire: checkIfW36Feature(player, gameType, isPreW37FrontierHirePlayer),
    isRichUnits: checkIfW36Feature(player, gameType, isPreW37RichUnitsPlayer),
    isCampArsenalHire: checkIfW36Feature(player, gameType, isPreW37CampArsenalHirePlayer),
  };
  return features.isThreatHire || features.isFrontierHire || features.isRichUnits || features.isCampArsenalHire
    ? features
    : null;
};

// Монета у Просветленных — очко (курс 1:1), при FANATICISM монеты покупаются за
// очки (3 очка → 4 монеты): запас им не «мертвый» — ни слотов F, ни дорогих
// типов E (как строгий режим конца партии волны 35); заслоны T — как у всех
export const checkIfW37CoinsArePoints = (player) => isPlayerFaction(player, FACTIONS.ENLIGHTENED)
  || isPlayerPolicy(player, POLICIES.FANATICISM);

// ---- Угроза городам (T, F)

/**
 * Ценность города для порядка заслонов (п. «по ценности города: очки + доход»):
 * очки захвата (calcCityWinPoints в записи угрозы — центр, строения, ключевые
 * точки, дворец и крепость) плюс доход ключевых точек города (рудник 1, большой
 * рудник 2, руины 2, большие руины 4) и по 1 за гильдию и храм. Доход бонуса за
 * город у всех городов одинаков и порядок не меняет
 */
export const calcW37CityDefenseValue = (city, cityWinPoints) => {
  let income = 0;
  Object.values(KEY_POINT_TOKENS).forEach((token) => {
    income += ((city && city[token]) || []).length * (KEY_POINT_INCOME[token] || 0);
  });
  income += ((city && city[SPECIAL_BUILDING_TOKENS.GUILD]) || []).length;
  income += ((city && city[SPECIAL_BUILDING_TOKENS.TEMPLE]) || []).length;
  return (cityWinPoints || 0) + income;
};

/**
 * Урон, который должен пережить заслон города с угрозой этого раунда: наибольшее
 * из урона по держателям модели волны 32 (threatDamage — только при держателях),
 * урона фантома (recruitDamage) и, при угрозе отрядами (level THIS_ROUND), урона
 * самого крупного живого врага, который уже стоит на квартале или ходит после
 * бота и дотягивается до клетки рядом с кварталом (скорость + доп. снабжение + 1
 * по гекс-дистанции, оценка сверху). Без держателей модель урона не считает
 */
export const calcW37GuardRequiredDamage = ({entry, liveEnemyUnits, laterMoverIds}) => {
  let unitDamage = 0;
  if (entry.level === CITY_THREAT_LEVELS.THIS_ROUND) {
    const quarterSet = new Set(entry.quarters);
    (liveEnemyUnits || []).forEach((enemy) => {
      const expectedDamage = Math.max(0, enemy.size - BOT_EXPECTED_DICE_PENALTY);
      if (expectedDamage <= unitDamage) {
        return;
      }
      if (quarterSet.has(enemy.hexKey)) {
        unitDamage = expectedDamage;
        return;
      }
      if (!laterMoverIds || !laterMoverIds.has(enemy.ownerId)) {
        return;
      }
      const range = (getUnitTypeConfig(enemy.type)?.speed || 2)
        + (enemy.additionalSupply === true ? ADDITIONAL_SUPPLY_SPEED : 0) + 1;
      if (entry.quarters.some((quarterHexKey) => getHexDistance(enemy.hexKey, quarterHexKey) <= range)) {
        unitDamage = expectedDamage;
      }
    });
  }
  return Math.max(entry.threatDamage || 0, entry.recruitDamage || 0, unitDamage);
};

// Порядок класса угрозы (больше — раньше): на 200 прод-реплеях города с угрозой
// отрядами (THIS_ROUND) захвачены в 49.9%, только фантомом живого — в 36%,
// только фантомом бота — в 4.5%
const THREAT_CLASS_RANKS = {UNITS: 2, HUMAN_RECRUIT: 1, BOT_RECRUIT: 0};

/**
 * T: города, которым в этом раунде нужен заслон. Угроза этого раунда
 * (checkIfW37ThisRoundThreat) и нет держателя, который переживет урон: держателей
 * нет, либо они под риском (isHolderAtRisk волны 32 при угрозе отрядами или
 * isRecruitHolderAtRisk фантома) — как getGuardNeededCityBarracks у угрозы
 * отрядами. Порядок — класс угрозы (отряды > фантом живого > фантом бота), затем
 * ценность города (calcW37CityDefenseValue), затем центральный квартал.
 * Возвращает [{entry, city, cityKey, requiredDamage, threatRank, value,
 *   hasOwnUnitOnBarracks}]: город со своим отрядом на казарме нового заслона не
 * получает (тот встает на квартал перемещением), но его отряду докупается размер
 */
export const collectW37ThreatGuardNeeds = ({cityThreats, units, currentPlayerId, laterMoverIds}) => {
  const liveEnemyUnits = (units || []).filter((unit) => unit.ownerId !== currentPlayerId
    && unit.ownerId !== NEUTRAL_PLAYER_ID);
  const needs = [];
  (cityThreats || []).forEach((entry) => {
    if (!checkIfW37ThisRoundThreat(entry)) {
      return;
    }
    const byUnits = entry.level === CITY_THREAT_LEVELS.THIS_ROUND;
    const isHolderAtRisk = (byUnits && entry.isHolderAtRisk) || entry.isRecruitHolderAtRisk === true;
    if (entry.holders.length > 0 && !isHolderAtRisk) {
      return;
    }
    const hasHumanRecruit = (entry.recruits || []).some((recruit) => !recruit.isEnemyBot);
    let threatRank = THREAT_CLASS_RANKS.BOT_RECRUIT;
    if (byUnits) {
      threatRank = THREAT_CLASS_RANKS.UNITS;
    } else if (hasHumanRecruit) {
      threatRank = THREAT_CLASS_RANKS.HUMAN_RECRUIT;
    }
    needs.push({
      entry,
      city: entry.city,
      cityKey: entry.city.centralQuarter,
      requiredDamage: calcW37GuardRequiredDamage({entry, liveEnemyUnits, laterMoverIds}),
      threatRank,
      value: calcW37CityDefenseValue(entry.city, entry.cityWinPoints),
      hasOwnUnitOnBarracks: entry.hasOwnUnitOnBarracks === true,
    });
  });
  return needs.sort((a, b) => b.threatRank - a.threatRank
    || b.value - a.value
    || String(a.cityKey).localeCompare(String(b.cityKey)));
};

/** Размер отряда с покупками размера, уже заявленными в этой фазе (применятся в конце этапа) */
export const calcUnitSizeWithPendingPurchases = (unit, pendingRecruitmentActions) => (pendingRecruitmentActions || [])
  .reduce((size, action) => (action.unitId === unit.id && action.actionType === 'SIZE_RECRUITMENT'
    ? size + (action.sizeAdded || 0)
    : size), unit.size);

/**
 * T: свои отряды на казармах городов из needs, которые пока не переживут урон
 * (размер с заявленными покупками не больше requiredDamage), но на максимуме
 * типа — переживут: им размер докупается раньше прочего, без накоплений.
 * Возвращает Set id
 */
export const collectW37WeakGuardIds = ({needs, ownUnits, pendingRecruitmentActions}) => {
  const ids = new Set();
  if (!needs || needs.length === 0) {
    return ids;
  }
  const ownUnitByCell = new Map((ownUnits || []).map((unit) => [unit.hexKey, unit]));
  needs.forEach((need) => {
    (need.city[COMMON_BUILDING_TOKENS.BARRACKS] || []).forEach((cellKey) => {
      const unit = ownUnitByCell.get(cellKey);
      if (!unit) {
        return;
      }
      const maxSize = unit.maxSize || getUnitTypeConfig(unit.type)?.maxSize || 0;
      if (calcUnitSizeWithPendingPurchases(unit, pendingRecruitmentActions) <= need.requiredDamage
        && maxSize > need.requiredDamage) {
        ids.add(unit.id);
      }
    });
  });
  return ids;
};

// ТОТАЛИТАРИЗМ: стартовый размер нового отряда (редьюсер RECRUIT_UNIT), прочие — 1
const TOTALITARIANISM_RECRUIT_SIZES = {
  [UNIT_TYPES.D10.id]: POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D10,
  [UNIT_TYPES.D20.id]: POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D20,
  [UNIT_TYPES.D8.id]: POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D8,
  [UNIT_TYPES.D12.id]: POLICY_TOTALITARIANISM_UNIT_RECRUITMENT_SIZE_D12,
};

/** Размер нового отряда типа unitTypeId сразу после найма */
export const calcW37RecruitInitialSize = (player, unitTypeId) => (
  isPlayerPolicy(player, POLICIES.TOTALITARIANISM) ? (TOTALITARIANISM_RECRUIT_SIZES[unitTypeId] || 1) : 1
);

/**
 * T: тип заслона. Годится тип, который с покупками размера в эту фазу
 * (calcW35HolderSizePurchases: по разу с незаблокированного квартала города, ×2
 * с рабочим арсеналом) переживет requiredDamage, проходит потолки (canHire) и по
 * карману: цена отряда и размера плюс coinMargin — не больше freeCoins. Из
 * годных: заслон, которого прокормят (isFed: казарма в снабжении, отряд в
 * пределах фермерского потолка), — первый по порядку typePreference, как у
 * прежнего заслона волны 32 (при isRich — E, большой запас — первый, после
 * которого остается не меньше richReserve); заслон, обреченный на голод (−2 в
 * следующей фазе снабжения), — самый дешевый, как d6-заслон волны 32.
 * Возвращает {best: {unitTypeId, price, cost, purchases} | null, reason} —
 * reason отказа: 'type' (никакой тип не переживет), 'cap' (потолки), 'coins'
 */
export const pickW37GuardType = ({
  typePreference, player, requiredDamage, sizePerPurchase, quartersCount, freeCoins, coinMargin,
  isFed = true, isRich = false, richReserve = 0, canHire,
}) => {
  let cheapest = null;
  let firstAffordable = null;
  let preferred = null;
  let hasViableType = false;
  let hasHireableType = false;
  (typePreference || []).forEach((unitTypeId) => {
    const unitConfig = getUnitTypeConfig(unitTypeId);
    if (!unitConfig) {
      return;
    }
    const sizePlan = calcW35HolderSizePurchases({
      initialSize: calcW37RecruitInitialSize(player, unitTypeId),
      expectedDamage: requiredDamage,
      maxSize: getUnitMaxSizeForFaction(unitTypeId, player.factionId),
      sizePerPurchase,
      quartersCount,
    });
    if (!sizePlan || !sizePlan.isEnough) {
      return;
    }
    hasViableType = true;
    if (!canHire(unitTypeId)) {
      return;
    }
    hasHireableType = true;
    const {price} = getUnitPrice(unitTypeId, player);
    const cost = price + sizePlan.purchases * getSizeRecruitmentPrice(unitConfig, player).sizePrice;
    if (freeCoins < cost + coinMargin || player.coins < price) {
      return;
    }
    const option = {unitTypeId, price, cost, purchases: sizePlan.purchases};
    if (!cheapest || cost < cheapest.cost) {
      cheapest = option;
    }
    if (!firstAffordable) {
      firstAffordable = option;
    }
    if (isRich && !preferred && freeCoins - cost >= richReserve) {
      preferred = option;
    }
  });
  const best = isFed ? (preferred || firstAffordable) : cheapest;
  if (best) {
    return {best, reason: null};
  }
  return {best: null, reason: !hasViableType ? 'type' : !hasHireableType ? 'cap' : 'coins'};
};

// ---- F: слоты сверх потолка армии под оборону фронтира

/**
 * Слоты армии сверх общего потолка при запасе freeCoins (монеты сверх
 * накоплений на стройку): первый — на пороге richCoins, далее +1 за каждые
 * richCoinsPerSlot, не больше richMaxExtraSlots; ниже порога — 0
 */
export const calcW37RichExtraSlots = (freeCoins, {richCoins, richCoinsPerSlot, richMaxExtraSlots}) => {
  if (!Number.isFinite(freeCoins) || freeCoins < richCoins) {
    return 0;
  }
  const extraSlots = 1 + Math.floor((freeCoins - richCoins) / Math.max(1, richCoinsPerSlot));
  return Math.max(0, Math.min(Math.floor(richMaxExtraSlots), extraSlots));
};

// Своим отрядом город «прикрыт», если тот стоит на квартале или рядом с ним
// (казарма, ферма, дорога у квартала) — радиус прежнего бонусного хука найма
const W37_CITY_COVER_RADIUS = 1;

/**
 * F: города для слотов сверх потолка — фронтирные (frontierCityKeys —
 * getW37FrontierCityKeys) без своего отряда на кварталах и рядом с ними.
 * Возвращает Set центральных кварталов
 */
export const collectW37FrontierUncoveredCityKeys = ({playerCities, frontierCityKeys, units, currentPlayerId}) => {
  const keys = new Set();
  if (!frontierCityKeys || frontierCityKeys.size === 0) {
    return keys;
  }
  const ownUnits = (units || []).filter((unit) => unit.ownerId === currentPlayerId);
  (playerCities || []).forEach((city) => {
    if (!frontierCityKeys.has(city.centralQuarter)) {
      return;
    }
    const quarters = getAllQuartersOfCity(city);
    const isCovered = ownUnits.some((unit) => quarters.some(
      (quarterHexKey) => getHexDistance(quarterHexKey, unit.hexKey) <= W37_CITY_COVER_RADIUS
    ));
    if (!isCovered) {
      keys.add(city.centralQuarter);
    }
  });
  return keys;
};

/**
 * F: казармы под слоты сверх потолка — казармы городов cityKeys
 * (collectW37FrontierUncoveredCityKeys) из candidateCells (свободные рабочие в
 * зоне снабжения, в их порядке внутри города). Порядок городов: угроза этого
 * раунда (checkIfW37ThisRoundThreat) > NEXT_ROUND или «скоро» > ближе к живому
 * противнику (гекс-дистанция от кварталов до его отрядов и кварталов,
 * enemySourceKeys) > ценнее город (calcW37CityDefenseValue) > порядок кэша городов.
 * threatByQuarter — getW37ThisRoundCityThreats(...).threatByQuarter (может быть
 * null); soonCityKeys — центральные кварталы городов под угрозой «скоро»
 * (назначение гарнизонов волны 35), null — «скоро» не учитывается
 */
export const sortW37FrontierHireCells = ({
  playerCities, cityKeys, candidateCells, threatByQuarter, soonCityKeys = null, enemySourceKeys,
}) => {
  if (!cityKeys || cityKeys.size === 0 || !candidateCells || candidateCells.length === 0) {
    return [];
  }
  const candidateIndex = new Map(candidateCells.map((cellKey, index) => [cellKey, index]));
  const entries = [];
  (playerCities || []).forEach((city, cityIndex) => {
    if (!cityKeys.has(city.centralQuarter)) {
      return;
    }
    const cells = (city[COMMON_BUILDING_TOKENS.BARRACKS] || [])
      .filter((cellKey) => candidateIndex.has(cellKey))
      .sort((a, b) => candidateIndex.get(a) - candidateIndex.get(b));
    if (cells.length === 0) {
      return;
    }
    const threat = threatByQuarter ? threatByQuarter.get(city.centralQuarter) : null;
    let threatRank = 0;
    if (checkIfW37ThisRoundThreat(threat)) {
      threatRank = 2;
    } else if ((threat && (threat.level >= CITY_THREAT_LEVELS.NEXT_ROUND || threat.isSoon === true))
      || (soonCityKeys && soonCityKeys.has(city.centralQuarter))) {
      threatRank = 1;
    }
    const quarters = getAllQuartersOfCity(city);
    let enemyDistance = Infinity;
    (enemySourceKeys || []).forEach((sourceKey) => {
      quarters.forEach((quarterHexKey) => {
        enemyDistance = Math.min(enemyDistance, getHexDistance(sourceKey, quarterHexKey));
      });
    });
    entries.push({
      cells,
      cityIndex,
      threatRank,
      enemyDistance,
      value: calcW37CityDefenseValue(city, threat ? threat.cityWinPoints : 0),
    });
  });
  entries.sort((a, b) => b.threatRank - a.threatRank
    || a.enemyDistance - b.enemyDistance
    || b.value - a.value
    || a.cityIndex - b.cityIndex);
  const seen = new Set();
  const ordered = [];
  entries.forEach((entry) => entry.cells.forEach((cellKey) => {
    if (!seen.has(cellKey)) {
      seen.add(cellKey);
      ordered.push(cellKey);
    }
  }));
  return ordered;
};

// ---- E: дорогие типы при большом запасе

/** E действует при этом запасе: порог richTypeCoins, кроме массовых инсектоидов и «монета = очко» */
export const checkIfW37RichTypesApply = (player, coins, {richTypeCoins}) => coins >= richTypeCoins
  && !isPlayerFaction(player, FACTIONS.INSECTOIDS)
  && !checkIfW37CoinsArePoints(player);

/**
 * E: порядок типов при большом запасе. Дорогие типы из предпочтений фракции
 * (максимум размера от d10: d10, d12, d20 — кавалерия d8 и пехота d6 нет,
 * катапульту бот не нанимает) идут первыми, от большего максимума к меньшему,
 * если после найма остается не меньше richTypeReserve монет; остальные — в
 * прежнем порядке после них. Типы не добавляются и не убираются: фракционные
 * правила (гномы без кавалерии, великаны только d20, крысолюды d12/d8 за
 * монеты) остаются в списке как были
 */
export const sortW37RichTypePreference = (preference, player, coins, {richTypeReserve}) => {
  const list = preference || [];
  const minExpensiveMaxSize = UNIT_TYPES.D10.maxSize;
  const expensive = list
    .map((unitTypeId, index) => ({unitTypeId, index, maxSize: getUnitTypeConfig(unitTypeId)?.maxSize || 0}))
    .filter(({unitTypeId, maxSize}) => maxSize >= minExpensiveMaxSize
      && coins - getUnitPrice(unitTypeId, player).price >= richTypeReserve)
    .sort((a, b) => b.maxSize - a.maxSize || a.index - b.index)
    .map(({unitTypeId}) => unitTypeId);
  if (expensive.length === 0) {
    return list;
  }
  const expensiveSet = new Set(expensive);
  return [...expensive, ...list.filter((unitTypeId) => !expensiveSet.has(unitTypeId))];
};

/**
 * E: d20 в раунде запрета (с R10) — на казарме у рабочего лагеря, пока до конца
 * партии остается не меньше d20CampMinSupplyPhases фаз снабжения
 * (roundLimit − round; без лимита партии — всегда)
 */
export const checkIfW37D20CampHireAllowed = ({round, roundLimit, isCampBarracks}, {d20CampMinSupplyPhases}) => (
  Boolean(isCampBarracks) && (roundLimit === null || roundLimit - round >= d20CampMinSupplyPhases)
);

// ---- A: казармы у лагеря и в городах с арсеналом

/**
 * A: порядок казарм найма. Закрепленные клетки (isPinned — заслоны угрожаемых
 * городов волны 32) остаются первыми в прежнем порядке; остальные — по группе
 * прежнего порядка (rankOf, меньше — раньше: ранги «сильных городов» волны 33
 * или «город без гарнизона» бонусного хука — оборону A не перебивает), внутри
 * группы — сначала казарма у рабочего лагеря (рост +4 вместо +2 в каждой фазе
 * снабжения), затем казарма города с рабочим арсеналом (размер за монеты ×2),
 * при равенстве — прежний порядок. Возвращает новый массив
 */
export const sortW37CampArsenalBarracks = (cells, {
  campCells, arsenalCells, isPinned = () => false, rankOf = () => 0,
}) => {
  const scoreOf = (cellKey) => (campCells && campCells.has(cellKey) ? 2 : 0)
    + (arsenalCells && arsenalCells.has(cellKey) ? 1 : 0);
  return (cells || [])
    .map((cellKey, index) => ({
      cellKey, index, pinned: isPinned(cellKey), rank: rankOf(cellKey), score: scoreOf(cellKey),
    }))
    .sort((a, b) => {
      if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
      if (!a.pinned && a.rank !== b.rank) return a.rank - b.rank;
      if (!a.pinned && a.score !== b.score) return b.score - a.score;
      return a.index - b.index;
    })
    .map((entry) => entry.cellKey);
};
